import {
  Tag,
  Bookmark,
  PersonStanding,
  MessageCircle,
  Search,
  Feather,
  Globe,
} from "lucide-react";
import type { ManuscriptMetadata } from "@/routes/innovation-days-demo/types";
import { CollapsibleCard } from "./CollapsibleCard";
import { BookDetailsContent } from "./BookDetailsContent";
import { WorldAndSettingContent } from "./WorldAndSettingContent";
import { CharactersContent } from "./CharactersContent";
import { QuotesContent } from "./QuotesContent";
import { MotifsContent } from "./MotifsContent";
import { USPContent } from "./USPContent";
import { ThemeContent } from "./ThemeContent";
import { TropesContent } from "./TropesContent";
import { SynopsisContent } from "./SynopsisContent";
import { ContentFlaggingContent } from "./ContentFlaggingContent";

interface OverviewCollapsiblesProps {
  manuscript: ManuscriptMetadata;
}

export function OverviewCollapsibles({
  manuscript,
}: OverviewCollapsiblesProps) {
  return (
    <div className="flex flex-col gap-3 md:gap-4 pb-4">
      <CollapsibleCard
        title="Book Details"
        icon={<Bookmark className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <BookDetailsContent manuscript={manuscript} />
      </CollapsibleCard>

      {manuscript.themes.length > 0 && (
        <CollapsibleCard
          title="Theme"
          icon={<Tag className="w-[18px] h-[18px] text-[#0F172A]" />}
          defaultOpen={false}
        >
          {(isExpanded) => (
            <ThemeContent themes={manuscript.themes} isExpanded={isExpanded} />
          )}
        </CollapsibleCard>
      )}

      {manuscript.synopsis && (
        <CollapsibleCard
          title="Synopsis"
          icon={<Feather className="w-[18px] h-[18px] text-[#0F172A]" />}
        >
          <SynopsisContent synopsis={manuscript.synopsis} />
        </CollapsibleCard>
      )}

      <CollapsibleCard
        title="Characters"
        icon={<PersonStanding className="w-[18px] h-[18px] text-[#0F172A]" />}
        defaultOpen={false}
      >
        {(isExpanded) => (
          <CharactersContent
            characters={manuscript.characters}
            isExpanded={isExpanded}
          />
        )}
      </CollapsibleCard>

      <CollapsibleCard
        title="World and Setting"
        icon={<Globe className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <WorldAndSettingContent settings={manuscript.settings} />
      </CollapsibleCard>

      <CollapsibleCard
        title="Content Flagging"
        icon={<Tag className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <ContentFlaggingContent flags={manuscript.content_flags} />
      </CollapsibleCard>

      <CollapsibleCard
        title="Quotes & Extracts"
        icon={<MessageCircle className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <QuotesContent topics={manuscript.quotes} />
      </CollapsibleCard>

      <CollapsibleCard
        title="Motifs"
        icon={<Search className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <MotifsContent motifs={manuscript.motifs} />
      </CollapsibleCard>

      <CollapsibleCard
        title="Unique Selling Points"
        icon={<Tag className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <USPContent usps={manuscript.usps} />
      </CollapsibleCard>

      <CollapsibleCard
        title="Tropes"
        icon={<Tag className="w-[18px] h-[18px] text-[#0F172A]" />}
      >
        <TropesContent tropes={manuscript.tropes} />
      </CollapsibleCard>
    </div>
  );
}
